import { useSyncExternalStore } from 'react'

let interval: ReturnType<typeof setInterval> | null = null
let tick = Date.now()
const listeners = new Set<() => void>()

const subscribe = (listener: () => void) => {
  listeners.add(listener)

  if (!interval) {
    interval = setInterval(() => {
      tick = Date.now()
      listeners.forEach((notify) => notify())
    }, 1000)
  }

  return () => {
    listeners.delete(listener)

    if (!listeners.size && interval) {
      clearInterval(interval)
      interval = null
    }
  }
}

const subscribeNoop = () => () => {}

const getSnapshot = () => tick
const getSnapshotStatic = () => 0

export const useSecondsTick = (enabled = true) =>
  useSyncExternalStore(
    enabled ? subscribe : subscribeNoop,
    enabled ? getSnapshot : getSnapshotStatic
  )
